<atn-ds-page>
  <atn-ds-table [config]="tenantsTableConfigSg()" />
  <atn-admin-tenant-modal />
</atn-ds-page>

@if (
  tenantsEc.plugins.editingPlugin.feature.selectors.hasDeletions.asSignal()
) {
  @let deletionError =
    tenantsEc.plugins.editingPlugin.feature.selectors.submissionError.asSignal();
  <atn-ds-confirmation-overlay
    title="Delete Tenant"
    [description]="
      'Are you sure you want to delete <b>' +
      tenantNameForDeleteSg() +
      '</b>? This action cannot be undone. ' +
      '<br> Please type <b>' +
      tenantNameForDeleteSg() +
      '</b> in the field below to confirm this action.'
    "
    [error]="deletionError"
    [validation]="tenantNameForDeleteSg()"
    (cancel)="cancelDeletionClickHandler()"
    (confirm)="confirmDeletionClickHandler()"
    confirmButtonText="Delete"
  />
}
